import {makeStyles} from "@material-ui/core/styles"
import {Icon, useTheme} from "@material-ui/core"
import UserEvent from "../../core/UserEvent"
import lang from "../../core/lang"
import IconButton from "@material-ui/core/IconButton"
import React from "react"
import i18n from "../../core/i18n";
import PropTypes from "prop-types";

const useStyles = makeStyles(theme => ({
    root: {
        borderRadius: '0px',
        padding: '0',
    },
    label: {
        backgroundColor: props => props.backgroundColor,
        padding: '0.3em',
        borderRadius: '0px',
    }
}))

function ToggleToolButton(props) {
    const {value, icon, style = {}, onClick, 'aria-label': ariaLabel} = props
    const theme = useTheme()
    const checked = lang.isFunction(props.checked) ? props.checked(value) : props.checked
    const backgroundColor = checked ? theme.palette.grey[300] : 'inherit'
    const classes = useStyles({backgroundColor})

    const handleMouseDown = event => {
        event.preventDefault()
        onClick && onClick(new UserEvent({value}, event))
    }

    const title = i18n.translate(props.title)

    return (
        <IconButton value={value} classes={classes} style={style} onMouseDown={handleMouseDown}
                    title={title} aria-label={i18n.translate(ariaLabel) || title} >
            <Icon fontSize="small" >{icon}</Icon>
        </IconButton>
    )
}

ToggleToolButton.propTypes = {
    value: PropTypes.string,
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    style: PropTypes.object,
    onClick: PropTypes.func,
    title: PropTypes.string,
    'aria-label': PropTypes.string,
    checked: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.func
    ])
}

export default ToggleToolButton